import React from 'react'
import { IoMdAdd } from 'react-icons/io'

const AddOrgBox = ({ onClick }) => {
  return (
    <div className='sm_add_org_box_con' onClick={onClick}>
          <div className='sm_add_org_box_circle'><IoMdAdd className='sm_add_org_box_icon' /></div>
    </div>
  )
}

export default AddOrgBox